import React, { useEffect, useState } from "react";
import { MdOutlineDateRange } from "react-icons/md";
import DatePicker from "react-date-picker";
import "./style.scss";

type Props = {
  title: string;
  isAllowed: boolean;
  data?: string;
  time?: Date;
  updateData: (val: string) => void;
  updateTime?: (val: Date) => void;
};

export const ProfileMultiInput: React.FC<Props> = ({
  title,
  isAllowed,
  data,
  time,
  updateData,
  updateTime,
}) => {
  const [date, setDate] = useState<any>(time || null);
  const [option, setOption] = useState<string>('N');
  const selectOptions = [{
    label: 'Yes',
    value: 'Y'
  }, {
    label: 'No',
    value: 'N'
  }];

  const handleOnChange = (selectedDate) => {
    if (updateTime) {
      updateTime(selectedDate);
    }

    setDate(selectedDate);
  };

  const updateSelectData = (value) => {
    switch (value) {
      case 'Y':
        setOption('Y');
        break;
    
      default:
        setOption('N');
        break;
    }
  }

  const handleSelectOnChange = (value) => {
    updateData(value);
    handleOnChange(new Date());
  };

  useEffect(() => {
    updateSelectData(data);
    
    if (time && Date.parse(time.toISOString()) > 0) {
      setDate(time);
    }
  }, [data, time]);

  return (
    <div className="profile-input-container">
      <>
        <span>{title}</span>
        <div className={isAllowed ? 'profile-input' : 'profile-input profile-input-disabled'}>
          <select
            value={option}
            onChange={(e: any) => handleSelectOnChange(e.target.value)}
            disabled={!isAllowed}
          >
            {selectOptions.map((option, index) => (
              <option key={index} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
        <div style={{ width: "20px" }}></div>
        <div className={isAllowed ? 'profile-multi-input' : 'profile-multi-input profile-multi-input-disabled'}>
          <DatePicker
            value={date}
            onChange={handleOnChange}
            disabled={!isAllowed}
            format="yyyy-MM-dd"
            calendarIcon={<MdOutlineDateRange />}
            clearIcon={null}
          />
        </div>
      </>
    </div>
  );
};
